// import shared css
// import('./scss/shared.scss');

const isBlockEditorCanvas = window.sccBlockEditor === true;

if (document.querySelector('.js-main-nav')) {

    import('./js/modules/navigation.js');

}

if (document.querySelector('.js-jumble')) {

    import('./js/common/text-animation.js');

}

if (document.querySelector('.js-interstitial')) {

    import('./js/common/interstitial.js');

}

if (document.querySelector('.lozad')) {

    import('./js/common/lozad.js');
    document.body.classList.add('lozad-library');

}

// we need alpine on the front-end, and in the wp editor
if (document.querySelector('.alpine-js') || document.querySelector('.wp-admin') || isBlockEditorCanvas) {

    const loadAlpine = () => {

        if (!document.body) {

            return false;

        }

        import('./js/common/alpine.js');
        document.body.classList.add('alpine-library');

        return true;

    };

    if (!loadAlpine()) {

        const bodyObserver = new MutationObserver(() => {

            if (loadAlpine()) {

                bodyObserver.disconnect();

            }

        });

        bodyObserver.observe(document, { childList: true, subtree: true });

    }

}

if (document.querySelector('.js-scroll-animate')) {

    import('./js/common/scroll-animation.js');
    document.body.classList.add('scroll-animation-library');

}

if (document.querySelector('#header')) {

    import('./js/common/scroll-trigger.js');

}

if (document.querySelector('.js-video-hero')) {

    import('./js/components/hero-video.js');

}

if (document.querySelector('iframe[src*="player.vimeo.com/video/"]')) {

    import('./js/components/vimeo-playback.js');

}
